export const extraColors = {
  'white-hi': '#FFFFFF', // 100%
  'white-md': '#FFFFFFDE', // 87%
  'white-lo': '#FFFFFF99', // 60%
  'black-hi': '#000000DE', // 87%
  'black-md': '#00000099', // 60%
  'black-lo': '#00000061', // 38%
};



// WEBPACK FOOTER //
// ./scripts/constants/extraColors.js